import type { TProfileAccess, TProfileAccessLevel } from "../store/user";

const UUID = /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/i;

export type PerfilDoCliente = {
  id: string;
  nome: string;
  nivel: TProfileAccessLevel;
};

/**
 * Empresas que o cliente pode abrir. O /users/me manda duas listas: a legada
 * ("publicId - nome"), com as fichas de que ele é dono E as concedidas, e a
 * estruturada (profileAccesses), só com as concedidas. Usar só a estruturada
 * escondia as fichas próprias de quem também recebeu acesso a outra; aqui
 * juntamos as duas. Ficha própria (fora dos acessos concedidos) é edição.
 */
export const perfisDoCliente = (legados: string[] = [], acessos: TProfileAccess[] = []): PerfilDoCliente[] => {
  const lista: PerfilDoCliente[] = acessos.map((acesso) => ({
    id: acesso.profilePublicId,
    nome: acesso.name?.trim() || "",
    nivel: acesso.accessLevel,
  }));
  for (const bruto of legados) {
    const id = bruto.match(UUID)?.[0];
    if (!id || lista.some((perfil) => perfil.id === id)) continue;
    const nome = bruto.replace(UUID, "").replace(/^\s*-\s*/, "").trim();
    lista.push({ id, nome, nivel: "EDIT" });
  }
  return lista;
};

/** Id puro do perfil, venha ele como "publicId - nome" ou só o publicId. */
export const idDoPerfil = (bruto?: string): string => bruto?.match(UUID)?.[0] ?? "";
